"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgFullcreen(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M6 10H4v6h6v-2H6zm0-4V2h4V0H4v6zm12 8h-4v2h6v-6h-2zM14 2h4v4h2V0h-6z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Fullcreen')(SvgFullcreen);
//# sourceMappingURL=Fullcreen.js.map